export const environment = {
	production: true,
	clientId: "679890777297-bvh3dqvgadlmshlq8ecq2v7i4ie72non.apps.googleusercontent.com", //admin+ - Web Application
	baseUrl: "https://ap-beta.trafera.app",
	apiUrl: "https://ap-beta-api.trafera.app",
};
